<template>
  <div>
    <!-- case study -->
    <div class="casetitle">Case Study</div>
    <div class="news">
      <div @click="btn('/media?source=caseStudy')" class="more">read more</div>
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Case Study/CaseStudy_backbase.png" alt="" class="backbase">
      <div class="newsList">
        <div class="one" v-for="(item,index) in caseList.slice(0,3)" :key="index" @click="toDetail(item.id,item.subscribe,item.newsTitle)">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/Case Study/CaseStudy_midshadow.png" alt="">
          <img :src="item.logo" class="newsLogo">
        </div>
      </div>
    </div>
    <el-dialog title="" :visible="DialogShow" width="45%" @close="DialogShow=false">
      <span>
        <div class="from">
          <div class="formtitle">Please fill in your information</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item label="First Name" prop="firstname">
              <el-input v-model="ruleForm.firstname" />
            </el-form-item>
            <el-form-item label="Last Name" prop="lastname">
              <el-input v-model="ruleForm.lastname" />
            </el-form-item>
            <el-form-item label="Email" prop="mail">
              <el-input v-model="ruleForm.mail" />
            </el-form-item>
            <el-form-item label="Company" prop="company">
              <el-input v-model="ruleForm.company" />
            </el-form-item>
            <!-- <div>We need your permission to stay in touch.</div> -->
            <el-form-item prop="check" style="width:100%">

              <input class="check" type="checkbox" v-model="ruleForm.check"><span style="word-break: break-word;">Yes, I would like to receive digital communications from Holden brands. I may opt-out of communications at any time using the unsubscribe link at the bottom of any email communication.</span>
            </el-form-item>
          </el-form>

        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogShow = false">cancel</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">submit</el-button>

      </span>
    </el-dialog>
  </div>
</template>

<script>
const defaultForm = {
  action: "News",
  actionCase: "Readnews",
  targetName: "",
  mail: "",
  firstname: "",
  lastname: "",
  company: "",
  check: true
};
import { getNewsList, actionRecords } from "@/api/api";

export default {
  data() {
    const check = (rule, value, callback) => {
      if (value == false) {
        return callback(new Error("Please complete this required field"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: JSON.parse(JSON.stringify(defaultForm)),
      rules: {
        firstname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        lastname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        company: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        mail: [
          { required: true, message: "Please complete this required field", trigger: "blur" },
          { type: "email", message: "Email must be formatted correctly.", trigger: ["blur"] }
        ]
        // check: [{ required: true, message: "Please complete this required field", trigger: "blur" }, { validator: check }]
      },
      DialogShow: false,
      caseList: []
    };
  },
  created() {
    this.getNewsList();
  },
  methods: {
    submitForm(formName) {
      let _this = this;
      // 数据写入表单
      _this.$refs[formName].validate(valid => {
        if (valid) {
          _this.ruleForm.fullName = _this.ruleForm.firstname + " " + _this.ruleForm.lastname;
          let ruleForm = {
            action: "News",
            actionCase: "Readnews",
            firstName: _this.ruleForm.firstname,
            fullName: _this.ruleForm.fullName,
            mail: _this.ruleForm.mail,
            company: _this.ruleForm.company
          };
          //   console.log(this.ruleForm);
          localStorage.setItem("form", JSON.stringify(this.ruleForm));
          var form = JSON.parse(localStorage.getItem("form"));
          form.targetName = this.submitTitle;
          console.log(form);
          // 提交表单数据
          actionRecords(form).then(res => {
            // console.log(form);
            // 如果没有cookie
            // 提交成功
            if (res.code == 10000) {
              // 关闭弹框
              this.DialogShow = false;
              // 如果是同意或者没点，存入cookie
              if (localStorage.getItem("agreeCookies")) {
                var val = localStorage.getItem("agreeCookies");
                var dataobj = JSON.parse(val);
                if (dataobj.val == "agree") {
                  this.$cookies.set("HoldenCookies", "panelDownloads");
                }
              } else if (this.$cookies.isKey("defaultcookies")) {
                this.$cookies.set("HoldenCookies", "panelDownloads");
              }

              // 跳转查看详情
              this.$router.push({ name: "newsDetail", query: { id: this.submitId, source: "casrStudy" } });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getNewsList() {
      getNewsList({
        pageSize: 4,
        pageIndex: 1,
        status: 1, //启用
        origin: 1, //前台
        firstLabelIds: [1, 7]
      }).then(res => {
        if (res.code != 10000) {
          this.$message.error(res.msg || "查询案例分享失败");
          return;
        }
        this.caseList = res.datalist || [];
        this.allCount = res.allCount;
      });
    },
    toDetail(id, subscribe, newsTitle) {
      // 如果需要权限但是没有cookies
      if (subscribe == 1 && !this.$cookies.isKey("HoldenCookies")) {
        this.submitId = id;
        this.DialogShow = true;
        this.submitTitle = newsTitle;
      }
      // 如果需要权限并且没有cookie
      else {
        this.$router.push({ name: "newsDetail", query: { id: id, source: "caseStudy" } });
      }
    },
    btn(path) {
      // 跳转页面
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.casetitle {
  // background-color: #fff;
  font-size: 40px;
  font-weight: 700;
  text-align: center;
  padding: 50px 120px 0 120px;
}
.news {
  margin: 0px 120px;
  font-size: 18px;
  position: relative;
  padding-bottom: 30px;
  img {
    width: 100%;
  }
  .backbase {
    margin-top: 50px;
  }
  // background-color: #fff;

  .more {
    // width: 160px;
    padding: 0 20px;
    font-size: 16px;
    color: #409eff;
    background-color: #ecf5ff;
    border: 1px solid #409eff;
    border-radius: 8px;
    text-align: center;
    position: absolute;
    right: 150px;
    // top: -30px;
  }
  .more:hover {
    cursor: pointer;
    color: #2cb1e9;
  }
  .newsList {
    // text-align: center;
    display: flex;
    justify-content: space-around;
    position: absolute;
    width: 100%;
    top: 40px;
    left: 30px;
    .one {
      cursor: pointer;
      width: 32%;
      // margin: 40px auto;
      position: relative;

      .newsLogo {
        width: 100%;
        position: absolute;
        left: 10px;
      }
    }
    .two {
      width: 40%;
    }
  }
}
.check {
  margin-right: 10px;
}
.from {
  // width: 60%;
  // margin: 80px auto;
  // padding: 30px;
  // transform: scale(1.3);
  padding-top: 0px;
  .formtitle {
    text-align: center;
    font-weight: 700;
    font-size: 25px;
    color: #ff0000;
  }
  @media screen and (max-width: 570px) {
    .formtitle {
      font-size: 45px;
    }
  }
  .el-form {
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    padding: 10px;
    /deep/ .el-form-item {
      display: inline-block;
      display: flex;
      // flex-wrap: wrap;
      justify-content: start;
      &:nth-child() {
        .el-form-item__label {
          // margin-left: 7px;
        }
      }
      &:not(.text) {
        // width: 50%;
      }
      &.text {
        width: 100%;
      }
      .el-form-item__content {
        font-size: 11px;
        line-height: 20px;
        flex: 1;
        .el-input {
          width: 238px !important;
        }
      }

      .el-form-item__label {
        width: 125px;
        font-size: 15px;
        display: block;
        font-weight: normal;
      }
      .el-textarea__inner {
        min-height: 104px !important;
      }
      .el-input__inner,
      .el-textarea__inner {
        background: #fafafa;
        border: 1px solid #e6e6e6;
        border-radius: 7px;
        font-size: 15px;
        width: 390px;
      }
      @media screen and (max-width: 576px) {
        .el-input__inner {
          font-size: 35px;
          width: 700px;
          height: 80px;
        }
        .el-form-item__label {
          font-size: 35px;
          width: 250px;
        }
        .el-form-item__content {
          font-size: 30px;
          line-height: 40px;
        }
      }
      .el-form-item__error {
        font-size: 12px !important;
      }
    }
  }
  & > * {
    margin: 20px;
  }
  div {
    margin-top: 12px;
  }
  .button {
    margin: 0 auto;
    margin-top: 20px;
    background: #217df6;
    font-size: 13px;
    color: #fff;
    border-radius: 7px;
    text-align: center;
    width: 150px;
    padding: 10px;
    // height: 34px;
    // line-height: 34px;
    cursor: pointer;
  }
  @media screen and (max-width: 576px) {
    .button {
      font-size: 35px;
    }
  }
}
@media screen and (max-width: 576px) {
  /deep/ .el-dialog__wrapper {
    .el-dialog {
      width: 100% !important;
      .el-dialog__footer {
        .el-button {
          font-size: 70px;
          padding: 20px;
        }
      }
    }
  }
  .casetitle {
    font-size: 80px;
  }
  .news {
    .bigtitle {
      font-size: 70px !important;
    }
    .more {
      font-size: 70px;
      // top: 130px;
      // top: -30px;
    }
    .more {
      top: -70px;
    }
    .casemore {
      top: 80px;
    }
    .newsList {
      padding-top: 30px;
      .one {
        width: 90%;
        img {
          height: auto;
        }
        .title {
          font-size: 70px;
        }
      }
    }
  }
}
</style>